import { useState, useEffect } from 'react';
import { FaExclamationTriangle, FaInfoCircle, FaTools, FaBullhorn, FaTag, FaSyncAlt } from 'react-icons/fa';
import { getAvisos, formatarData } from '../../services/api/avisosApi';
import './avisos.css';

const ListaAvisos = ({ onAvisoSelect }) => {
  const [avisos, setAvisos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Mapeamento de tipos do backend para labels em português
  const tiposAvisos = {
    info: "Informação",
    warning: "Aviso",
    alert: "Alerta",
    maintenance: "Manutenção",
    promotion: "Promoção",
    update: "Atualização"
  };

  useEffect(() => {
    carregarAvisos();
  }, []);

  const carregarAvisos = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await getAvisos();
      setAvisos(data);
    } catch (err) {
      setError('Não foi possível carregar os avisos. Tente novamente.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const traduzirTipo = (tipo) => {
    return tiposAvisos[tipo] || tipo;
  };

  const getIconePorTipo = (tipo) => {
    switch (tipo) {
      case 'maintenance':
        return <FaTools className="aviso-icon manutencao" />;
      case 'alert':
        return <FaExclamationTriangle className="aviso-icon alerta" />;
      case 'warning':
        return <FaBullhorn className="aviso-icon warning" />;
      case 'promotion':
        return <FaTag className="aviso-icon promocao" />;
      case 'update':
        return <FaSyncAlt className="aviso-icon update" />;
      case 'info':
      default:
        return <FaInfoCircle className="aviso-icon informativo" />;
    }
  };

  const getClassePorTipo = (tipo) => {
    switch (tipo) {
      case 'maintenance':
        return 'aviso-card manutencao';
      case 'alert':
        return 'aviso-card alerta';
      case 'warning':
        return 'aviso-card warning';
      case 'promotion':
        return 'aviso-card promocao';
      case 'update':
        return 'aviso-card update';
      case 'info':
      default:
        return 'aviso-card informativo';
    }
  };

  const formatarDataLocal = (dataString) => {
    if (!dataString) return '';
    return formatarData(dataString);
  };

  const avisosFiltrados = avisos;

  if (loading) {
    return (
      <div className="avisos-container">
        <div className="avisos-loading">
          <div className="spinner"></div>
          <p>Carregando avisos...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="avisos-container">
        <div className="avisos-error">
          <FaExclamationTriangle />
          <p>{error}</p>
          <button onClick={carregarAvisos} className="retry-button">
            Tentar Novamente
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="avisos-container">
      {avisosFiltrados.length > 0 && (
        <p className="avisos-count">{avisosFiltrados.length} {avisosFiltrados.length === 1 ? 'aviso' : 'avisos'}</p>
      )}

      <div className="avisos-lista">
        {avisosFiltrados.length === 0 ? (
          <div className="avisos-vazio">
            <FaInfoCircle />
            <p>Nenhum aviso disponível no momento.</p>
          </div>
        ) : (
          avisosFiltrados.map((aviso) => (
            <div 
              key={aviso.id} 
              className={getClassePorTipo(aviso.type)}
              onClick={() => onAvisoSelect && onAvisoSelect(aviso)}
            >
              <div className="aviso-header-card">
                {getIconePorTipo(aviso.type)}
                <div className="aviso-info">
                  <h3>{aviso.title}</h3>
                  <span className="aviso-tipo-badge">{traduzirTipo(aviso.type) || 'Informação'}</span>
                </div>
              </div>
              {aviso.description && (
                <p className="aviso-descricao">{aviso.description}</p>
              )}
              {aviso.publishDate && (
                <span className="aviso-data">{formatarDataLocal(aviso.publishDate)}</span>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ListaAvisos;
